

<script>
export default {
  name: 'BettingPromotionsCard',
  props: {
    promotion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    meetingEventsText() {
      const { events } = this.promotion;
      const noOfEvents = events.length;
      const eventArray = events.constructor === Array ? events : [events];
      const orderedEvents = noOfEvents > 1 ? events.sort((a, b) => a.eventNumber - b.eventNumber) : eventArray;
      if (noOfEvents > 1) {
        return `${this.promotion.meetingName} R${orderedEvents[0].eventNumber}-R${
          orderedEvents[noOfEvents - 1].eventNumber
        }`;
      }
      return `${this.promotion.meetingName} R${orderedEvents[0].eventNumber}`;
    },
  },
  methods: {
    toggleTCsModal(isActive, text) {
      this.$store.dispatch('BettingPromotions/toggleModalStatus', { isActive, text });
    },
  },
};
</script>

<template>
  <div class="betting-promotions-card">
    <div :class="`betting-promotions-card__header ${promotion.bookmaker}`">
      <img
        :src="`https://puntcdn.com/Logos/${promotion.bookmaker}/lightondark.svg`"
        :alt="`${promotion.bookmaker}`"
        class="betting-promotions-card__bookie-image"
      >
      <div v-if="promotion.deal && promotion.deal !== ''" class="betting-promotions-card__deal">
        Up to
        <div class="betting-promotions-card__deal-value">${{ promotion.deal }}</div>
      </div>
    </div>
    <div class="betting-promotions-card__details">
      <div class="betting-promotions-card__event-info">
        <div class="betting-promotions-card__event-name">{{ meetingEventsText }}</div>
        <div
          class="betting-promotions-card__event-date"
        >{{ promotion.meetingDate | sportsCalendarPunters }}</div>
      </div>
      <div class="betting-promotions-card__promotion-info">
        <div class="betting-promotions-card__promo-header">{{ promotion.heading1 }}</div>
        <div class="betting-promotions-card__promo-details">{{ promotion.heading2 }}</div>
      </div>
      <div class="betting-promotions-card__promotion-footer">
        <div
          class="betting-promotions-card__tcs"
          @click.stop
          @click.prevent="toggleTCsModal(true, promotion.terms)"
        >T&C's apply</div>
        <a
          :href="promotion.primaryBookmakerUrl"
          :class="`betting-promotions-card__offer-btn ${promotion.bookmaker}`"
        >
          <p>{{ promotion.primaryBookmakerUrlLabel }}</p>
        </a>
      </div>
    </div>
  </div>
</template>
